import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const deletetodo = createAsyncThunk('deletetodos', async (id) => {
  const res = await axios.delete('https://jsonplaceholder.typicode.com/posts',{
    headers:{
      'x-delete-id':id,
    }
  });
  return res.data;
});

const deleteslice = createSlice({
  name: 'delete',
  initialState: {
    loading: false,
    error: null,
    data: null,
    isSuccess: false,
    isError: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deletetodo.pending, (state) => {
        state.loading = true;
        state.isError = false;
        state.isSuccess = false;
        state.data = null;
        state.error = null;
      })
      .addCase(deletetodo.rejected, (state, action) => {
        state.loading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
        state.error = action.payload || action.error.message;
      })
      .addCase(deletetodo.fulfilled, (state, action) => {
        state.loading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      });
  }
});

export default deleteslice.reducer;
